module.exports = __webpack_public_path__ + "static/media/7.cfc3b4b6.mp3";